var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10.5,
    r: 6,
    stroke: "#1B1836",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65092 25.2508C9.57272 22.5319 12.2717 21 15.1426 21H20.8574C23.7283 21 26.4273 22.5319 27.3491 25.2508C27.8733 26.797 28.3373 28.6275 28.4652 30.5007C28.5028 31.0517 28.0523 31.5 27.5 31.5H8.5C7.94772 31.5 7.49717 31.0517 7.53479 30.5007C7.66267 28.6275 8.12668 26.797 8.65092 25.2508Z",
    stroke: "#1B1836",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.36c21207cc6a051b276e81685b5f0240.svg";
export { ForwardRef as ReactComponent };